import { Injectable } from '@angular/core';
import { InvestorDashboardPortfolioSeriesBalanceSummary } from '../models/classes/investor-dashboard.class';

@Injectable({
  providedIn: 'root'
})
export class MathComputationService {

  roundNumber(number: number, devideBy: number, decimalPoints: number) {
    const powerOfTen = Math.pow(10, decimalPoints);
    return Number((Math.round((number / devideBy) * powerOfTen) / powerOfTen).toFixed(decimalPoints)).toLocaleString('en', { minimumFractionDigits: decimalPoints });
  }

  filterChartDataBeforeSpecificYear(data: InvestorDashboardPortfolioSeriesBalanceSummary[]) {
    if(!data) return [];
    return data.filter((d: InvestorDashboardPortfolioSeriesBalanceSummary) => new Date(d.reportingPeriod).getFullYear() > 2022)
  }
}
